// API configuration for client
// Smart detection:
// - In development (localhost): use http://localhost:5001
// - In production (any other domain): use same origin (empty string = relative paths)
const getBaseUrl = (): string => {
  // If REACT_APP_API_URL is explicitly set, use it (for custom configurations)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Auto-detect based on hostname
  const hostname = window.location.hostname;

  // Development: localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:5001';
  }

  // Production: use same origin (server serves the client)
  return '';
};

export const API_URL = getBaseUrl();

export const getApiUrl = (path: string): string => {
  return `${API_URL}${path}`;
};
